<template>
    <div class="shapan-container">
        <div class="shapan" v-for="item in shapanList" :key="item.id">
            <h1 class="title">{{item.title}}</h1>
            <img :src="item.src" @click="toDetail(item)">
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            shapanList: [
                {
                    id: 1,
                    title: '2020年沙盘',
                    src: 'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/jinrong/jinrong-map.jpg',
                    url: 'http://izt.eastfair.cn/shapan/index.html'
                },
                // {
                //     id: 2,
                //     title: '2021年沙盘',
                //     src: 'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/jinrong/jinrong-map.jpg',
                //     url: ''
                // }
            ]
        }
    },
    methods: {
        toDetail(item) {
            const el = document.createElement('a')
            document.body.appendChild(el)
            el.href = item.url
            el.target = '_blank' //指定在新窗口打开
            el.click()
            document.body.removeChild(el)
        }
    }
}
</script>

<style scoped>
.shapan-container {
    padding: 16px;
    box-sizing: border-box;
    max-width: 900px;
    margin: 0 auto;
}
.shapan-container .shapan {
    font-size: 0;
}
.shapan-container .shapan .title {
    text-align: center;
    font-size: 16px;
}
.shapan-container .shapan img {
    width: 100%;
    height: 100%;
    display: inline-block;
}

</style>
